import { render } from "./AppButtonSmall.vue?vue&type=template&id=3d95b94d&scoped=true"
import script from "./AppButtonSmall.vue?vue&type=script&lang=js"
export * from "./AppButtonSmall.vue?vue&type=script&lang=js"

import "./AppButtonSmall.vue?vue&type=style&index=0&id=3d95b94d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d95b94d"]])

export default __exports__